import type React from "react";

import { cn } from "@ui/lib/utils";

interface AudioWidgetPillProps {
  children: React.ReactNode;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}

const AudioWidgetPill = ({ children, className, ref }: AudioWidgetPillProps) => {
  return (
    <div
      ref={ref}
      className={cn(
        "tw-flex tw-items-center tw-gap-[10px]",
        "tw-rounded-[30px] tw-backdrop-blur-[30px]",
        "tw-bg-[rgba(245,242,239,0.8)]",
        "tw-border-0.5 tw-border-solid tw-border-[rgba(0,0,0,0.1)]",
        "tw-shadow-[0px_6px_16px_0px_rgba(78,50,23,0.04)]",
        className,
      )}
    >
      {children}
    </div>
  );
};

AudioWidgetPill.displayName = "AudioWidgetPill";

export { AudioWidgetPill };
export type { AudioWidgetPillProps };
